export default {
  name: 'marking--nkGoodsCheckGtin',
  apiService: 'shoes',
  apiPath: '/admin/nkgoods/func/gtin_check',
  urlParamName: 'marking--nkGoodsCheckGtin',
};
